import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button, Spinner } from "react-bootstrap";
import axios, { get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../../../config";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Search from "../../../Helper/CustomSearch";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import { MdDateRange } from "react-icons/md";
import { HiOutlineTrash } from "react-icons/hi";
import { FaTimes } from "react-icons/fa";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InventoryCalendarModal from "./InventoryCalendarModal";

const InventoryMandap = () => {
  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  const breadcrumbData = [
    { title: "Masters", href: "/masters" },
    { title: "Inventory Mandap", href: "#" },
  ];

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [calendarModal, setCalendarModal] = useState({
    open: false,
    mandapId: null,
    mandapName: "",
    stateName: "",
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [selDeleteRow, setSelDeleteRow] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const initialData = (searchTerm = "") => {
    setLoading(true);
    const url = searchTerm
      ? `${config.service}/masters/inventory_mandap/?search=${searchTerm}`
      : `${config.service}/masters/inventory_mandap/`;
    get(url, tokenKey)
      .then((res) => {
        const data = res.data.results || res.data;
        setTableData(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        setLoading(false);
      });
  };

  useEffect(() => {
    initialData();
  }, []);

  const openCalendar = (row) => {
    setCalendarModal({
      open: true,
      mandapId: row.id,
      mandapName: row.mandap_name,
      stateName: row.state_name || "",
    });
  };

  const closeCalendar = () => {
    setCalendarModal({ open: false, mandapId: null, mandapName: "", stateName: "" });
  };

  const handleDeleteInventory = () => {
    if (!selDeleteRow) return;
    setDeleteLoading(true);
    axios
      .patch(
        `${config.service}/masters/vendor_mandap/${selDeleteRow.id}/`,
        { is_inventory_purchased: false, dates: [] },
        tokenKey
      )
      .then(() => {
        toast.success("Inventory cleared successfully", toastAttr);
        setDeleteModal(false);
        setSelDeleteRow(null);
        setDeleteLoading(false);
        initialData();
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        toast.error("Failed to clear inventory", toastAttr);
        setDeleteLoading(false);
      });
  };

  const cols = [
    {
      dataField: "id",
      text: "ID",
      headerStyle: () => ({ width: "80px" }),
    },
    {
      dataField: "mandap_name",
      text: "Mandap Name",
      headerStyle: () => ({ width: "220px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "vendor_name",
      text: "Vendor",
      headerStyle: () => ({ width: "180px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "city_name",
      text: "City",
      headerStyle: () => ({ width: "130px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "area_name",
      text: "Area",
      headerStyle: () => ({ width: "130px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "inventory_date_count",
      text: "Dates",
      headerStyle: () => ({ width: "80px" }),
      formatter: (cell) => (
        <span
          style={{
            background: cell > 0 ? "#d4edda" : "#f8d7da",
            border: `1px solid ${cell > 0 ? "#28a745" : "#dc3545"}`,
            borderRadius: 4,
            padding: "1px 8px",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {cell || 0}
        </span>
      ),
    },
    {
      dataField: "id",
      text: "Actions",
      isDummyField: true,
      headerStyle: () => ({ width: "160px" }),
      events: { onClick: (e) => e.stopPropagation() },
      formatter: (cell, row) => (
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <Button
            variant="outline-primary"
            size="sm"
            style={{ fontSize: "12px" }}
            onClick={() => openCalendar(row)}
          >
            <MdDateRange style={{ marginRight: 4, fontSize: 14 }} />
            Dates
          </Button>
          <HiOutlineTrash
            title="Clear Inventory"
            className="themeColor actionIcon"
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              setSelDeleteRow(row);
              setDeleteModal(true);
            }}
          />
        </div>
      ),
    },
  ];

  const options = paginationFactory({
    sizePerPage: 20,
    paginationSize: 3,
    hideSizePerPage: true,
    totalSize: tableData.length,
    hidePageListOnlyOnePage: true,
  });

  return (
    <Container className="vendor">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <Row className="formBtnsDiv mar-b-10">
                <Col md={8} />
                <Col md={4}>
                  <Search callbackFn={(e) => initialData(e)} />
                </Col>
              </Row>
              <Row
                className="vendorList justify-content-center align-items-center"
                style={{ minHeight: "80vh" }}
              >
                {loading ? (
                  <div className="text-center">
                    <Spinner animation="border" role="status" size="sm" />
                    <span className="ml-1">Loading...</span>
                  </div>
                ) : (
                  <BootstrapTable
                    bootstrap4
                    wrapperClasses="table-responsive pad-20"
                    data={tableData}
                    columns={cols}
                    keyField="id"
                    containerStyle={{ width: "100%" }}
                    hover
                    noDataIndication="No inventory mandaps found"
                    pagination={options}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <InventoryCalendarModal
        open={calendarModal.open}
        onClose={closeCalendar}
        mandapId={calendarModal.mandapId}
        mandapName={calendarModal.mandapName}
        stateName={calendarModal.stateName}
        tokenHeaders={tokenKey.headers}
        onSaved={() => initialData()}
      />

      {/* Delete / Clear Inventory Confirmation */}
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)} maxWidth="sm">
        <DialogTitle>
          Confirm Clear Inventory
          <FaTimes
            onClick={() => setDeleteModal(false)}
            className="popup-close"
            title="close"
            style={{ cursor: "pointer", float: "right" }}
          />
        </DialogTitle>
        <DialogContent>
          <div style={{ paddingRight: "30px" }}>
            This will set <strong>is_inventory = false</strong> and clear all dates for{" "}
            <strong>{selDeleteRow?.mandap_name}</strong>. Continue?
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteInventory} disabled={deleteLoading}>
            {deleteLoading ? <Spinner animation="border" size="sm" /> : "Confirm"}
          </Button>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default InventoryMandap;
